import { all, put, takeEvery, take } from 'redux-saga/effects';
import { toSuccess } from 'react-async-client';
import { propOr, last, path } from 'ramda';
import counterpart from 'counterpart';
import pluralizeRu from 'counterpart/locales/ru';
import moment from 'moment';
import qs from 'qs';
import 'moment/locale/ru';

import en from '../translate/en';
import ru from '../translate/ru';
import HR from '../translate/versions/HR';
import KA from '../translate/versions/KA';
import ancor from '../translate/versions/ancor';

import { isAncor, getVersion } from 'utils/version';
import { addDefaultHeader } from 'utils/http';
import { APP_RUN, CHANGE_LANGUAGE, GET_USER, GET_COMPANY_INFO } from 'constants/actionTypes';
import { changeLanguage } from 'actions/appActions';

const defaultLanguage = 'ru';

export const supportedLanguages = {
    'ru': 'ru',
    'en': 'en',
    'ru-ru': 'ru',
    'russian': 'ru',
    'english': 'en',
    'en-gb': 'en',
    'en-us': 'en'
};

const versionLocales = {
    'HR': HR,
    'KA': KA,
    'ANCOR': KA
};

const detectLanguage = () => {
    const storageLanguage = localStorage && localStorage.getItem('language');
    const browserLanguage = (window.navigator.userLanguage || window.navigator.language || '').toLowerCase();
    const locationLanguage = path(['lang'], qs.parse(last(window.location.hash.split('?'))));
    const language = locationLanguage || storageLanguage || browserLanguage || counterpart.getLocale();

    return language;
};

const getLanguage = (language) => {
    return propOr(defaultLanguage, language, supportedLanguages);
};

const getLocale = language => language === defaultLanguage ? 'ru-ru' : 'en-us';
const getNextLanguage = () => counterpart.getLocale() === defaultLanguage ? 'en' : defaultLanguage;

const setLanguage = (language) => {
    counterpart.setLocale(language);
    moment.locale(language);
    addDefaultHeader('Accept-Language', getLocale(language));
    localStorage && localStorage.setItem('language', language);
};

export default function* () {
    yield all([
        takeEvery(toSuccess(GET_USER), function () {
            let locale = counterpart.getLocale();

            const versionTranslate = versionLocales[getVersion()] || versionLocales.KA;
            counterpart.registerTranslations('ru', versionTranslate.ru);
            counterpart.registerTranslations('en', versionTranslate.en);

            if (isAncor()) {
                counterpart.registerTranslations('ru', ancor);
                locale = 'ru';
            }

            setLanguage(locale);
            counterpart.emit('localechange', locale, locale);
        }),
        takeEvery(CHANGE_LANGUAGE, function (action) {
            const language = getLanguage(action.payload || getNextLanguage());
            setLanguage(language);
        }),
        takeEvery(toSuccess(GET_COMPANY_INFO), function (action) {
            if (action.payload.isAncor) {
                setLanguage('ru');
            }
        })
    ]);

    counterpart.registerTranslations('ru', ru);
    counterpart.registerTranslations('ru', pluralizeRu);
    counterpart.registerTranslations('en', en);

    yield take(APP_RUN);
    yield put(changeLanguage(detectLanguage()));
}
